import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Spacer } from 'foundations-components/components/Spacer';
import { Link } from 'foundations-components/transitional/components/Link';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { useApp } from '../../contexts/AppContext';
import { useFetchInstalledUsers } from '../../hooks/queries/useFetchInstalledUsers';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { useRevokeApproval } from '../../hooks/mutations/useRevokeApproval';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function RevokeApprovalModal({
  onClose,
  showUsersWithInstallAccessDrawer
}) {
  const {
    data: {
      infoForInstalledUsers
    }
  } = useFetchInstalledUsers();
  const {
    appName
  } = useApp();
  const installedByUsersCount = infoForInstalledUsers.length;
  const {
    revokeApproval,
    loading,
    error
  } = useRevokeApproval();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(ConfirmModal, {
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app-governance-lib.revokeApproval.title"
      }),
      description: /*#__PURE__*/_jsxs(_Fragment, {
        children: [installedByUsersCount > 0 && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "app-governance-lib.revokeApproval.modal.descriptionWithInstalledUsers",
            options: {
              appName,
              count: installedByUsersCount
            }
          }), /*#__PURE__*/_jsx(Spacer, {})]
        }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "app-governance-lib.revokeApproval.modal.descriptionWithUsersWhoCanReinstall_jsx",
          options: {
            linkProps: {
              onClick: () => {
                showUsersWithInstallAccessDrawer();
              }
            }
          },
          elements: {
            Link
          }
        })]
      }),
      match: appName,
      matcherLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app-governance-lib.revokeApproval.modal.matcherLabel"
      }),
      onReject: onClose,
      confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app-governance-lib.revokeApproval.modal.confirmLabel"
      }),
      ConfirmButton: LoadingButton,
      confirmButtonProps: {
        use: 'danger',
        loading,
        failed: !!error
      },
      onConfirm: revokeApproval,
      rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app-governance-lib.revokeApproval.modal.rejectLabel"
      })
    })
  });
}